import { Globe } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { Button } from './ui/button';
import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
];

export const LanguageSelector = ({ variant = 'default' }) => {
  const { i18n } = useTranslation();
  const activeLang = (i18n.language || 'fr').substring(0, 2);
  const currentLang = languages.find(l => l.code === activeLang) || languages[0];

  const changeLang = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem('language', code);
  };

  const renderItems = () =>
    languages.map((item) => (
      <DropdownMenuItem
        key={item.code}
        onClick={() => changeLang(item.code)}
        className={`cursor-pointer ${activeLang === item.code ? 'bg-emerald-500/20 text-emerald-400' : 'text-zinc-300 hover:bg-zinc-800'}`}
        data-testid={`lang-${item.code}`}
      >
        <span className="mr-2 text-lg">{item.flag}</span>
        {item.name}
      </DropdownMenuItem>
    ));

  if (variant === 'minimal') {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm" className="gap-1 text-zinc-400 hover:text-white" data-testid="language-selector">
            <span className="text-lg">{currentLang.flag}</span>
            <span className="hidden sm:inline text-xs uppercase">{currentLang.code}</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="bg-zinc-900 border-zinc-700">
          {renderItems()}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2 text-zinc-400 hover:text-white hover:bg-zinc-800" data-testid="language-selector">
          <Globe className="w-4 h-4" />
          <span className="text-lg">{currentLang.flag}</span>
          <span className="hidden md:inline">{currentLang.name}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-zinc-900 border-zinc-700">
        {renderItems()}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
